<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.Code" type="text" 
                                     label="Code *" 
                                     autofocus 
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('Code')"
                                     :error-message="fieldErrorMessage('Code')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.CarrierName" type="text" 
                                     label="Carrier" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('CarrierName')"
                                     :error-message="fieldErrorMessage('CarrierName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-select v-model="model.CarrierType" 
                                      label="Carrier Type *" 
                                       
                                       
                                      :options="dataSourceCarrierType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('CarrierType')"
                                      :error-message="fieldErrorMessage('CarrierType')"
                                      
                                      @input="onCarrierTypeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.SCAC" type="text" 
                                     label="SCAC" 
                                      
                                      maxlength="64"
                                      
                                     :rules="[]"
                                     :error="fieldHasError('SCAC')"
                                     :error-message="fieldErrorMessage('SCAC')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.ServiceName" type="text" 
                                     label="Service *" 
                                      
                                      maxlength="255"
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('ServiceName')"
                                     :error-message="fieldErrorMessage('ServiceName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-checkbox v-model="model.IsActive" 
                                        label="Is Active" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>
<div class="col-6" >
                            <q-checkbox v-model="model.IsCustom" 
                                        label="Is Custom" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.CustomTradingPartnerCodes" type="textarea" rows="8" 
                                     label="Trading Partner Codes (comma-separated)" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('CustomTradingPartnerCodes')"
                                     :error-message="fieldErrorMessage('CustomTradingPartnerCodes')"
                                     
                                     dense>
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './canonicalcodeaddeditmodel-dialog-screen.js'
</script>